/**
 * Constants for Layer Exposed feature
 * Contains filter keywords, field types, dataset names, and messages
 */

export class LayerExposedConstants {
    // Field name filters for TIV (Total Insured Value)
    static readonly TIV_FILTER_KEYWORDS = {
        TIV: 'TIV',
        TOTAL_INSURED_VALUE: 'TOTAL INSURED VALUE',
        IMPROVEMENT: 'IMPROVEMENT',
        BETTERMENT: 'BETTERMENT'
    };

    // Field name filters for Deductibles (regex patterns)
    static readonly DEDUCTIBLE_FILTER_KEYWORDS = {
        MINIMUM_DEDUCTIBLE: /MINIMUM\s*DEDUCTIBLE/i,
        MAXIMUM_DEDUCTIBLE: /MAXIMUM\s*DEDUCTIBLE/i
    };

    // Calculation Types
    static readonly CALCULATION_TYPE = {
        BASIC: 'BASIC',
        WITH_DEDUCTIBLE: 'WITH_DEDUCTIBLE',
        // Legacy types for backward compatibility
        LAYER_EXPOSED: 'LAYER_EXPOSED',
        LAYER_EXPOSED_WITH_DEDUCTIBLE: 'LAYER_EXPOSED_WITH_DEDUCTIBLE'
    };

    // Field Types
    static readonly FIELD_TYPE = {
        NUMBER_FIELD: 'NUMBER_FIELD',
        TEXT_FIELD: 'TEXT_FIELD',
        SHORT_TEXT_FIELD: 'SHORT_TEXT_FIELD',
        LONG_TEXT_FIELD: 'LONG_TEXT_FIELD'
    };

    // Dataset Names
    static readonly DATASET_NAME = {
        LOCATIONS: 'Locations',
        POLICIES: 'Policies',
        POLICY: 'Policy'
    };

    // Success Messages
    static readonly SUCCESS_MESSAGE = {
        CREATED: 'Successfully created layer exposed',
        UPDATED: 'Successfully updated layer exposed',
        APPLIED_FLAG_UPDATED: 'The layer exposed applied flag has been updated.',
        DELETED: 'The layer exposed has been deleted.'
    };

    // Error Messages
    static readonly ERROR_MESSAGE = {
        LOAD_EQUATION_FAILED: 'Failed to load equation data. Please try again.',
        LOAD_ALL_EQUATIONS_FAILED: 'Failed to load data for all equations. Please try again.',
        UNEXPECTED_ERROR: 'An unexpected error occurred while refreshing data',
        NO_DATA_TO_DOWNLOAD: 'No data available to download',
        NO_EQUATION_SELECTED: 'Please select at least one equation to download',
        DOWNLOAD_REQUEST_FAILED: 'Unable to generate download request',
        DOWNLOAD_FAILED: 'Something went wrong during download'
    };

    // Download Settings
    static readonly DOWNLOAD = {
        FILE_NAME: 'Exposed Layer Accumulation.xlsx'
    };

    // Column Names
    static readonly COLUMN_NAME = {
        POLICY_NUMBER: 'policynumber',
        COUNT: 'count'
    };
}
